import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { GET_SONGBOOK } from '../../graphql/queries/songbook/songbook';
import { appendAccessToken } from '../../utils/user';
import {
  dismissLoadingMessage,
  displayErrorMessage,
  displayLoadingMessage,
} from '../../utils/helpers';

const useGetSongbook = (id) => {
  const [processedData, setProcessedData] = useState(null);

  const appendTokenToSongbookAssets = (songbook) => {
    const stringKeys = [
      'imageFileOriginal',
      'imageFileLarge',
      'imageFileMedium',
    ];
    const modifiedSongbook = { ...songbook };
    stringKeys.forEach((key) => {
      modifiedSongbook[key] = appendAccessToken(modifiedSongbook[key]);
    });
    const modifiedResources = songbook?.resources?.map((resource) => {
      const modifiedResource = { ...resource };
      if (resource.pdfFile) {
        modifiedResource.pdfFile = appendAccessToken(modifiedResource.pdfFile);
      }
      if (resource.sfxFile) {
        modifiedResource.sfxFile = appendAccessToken(resource.sfxFile);
      }
      return modifiedResource;
    });
    return { ...modifiedSongbook, resources: modifiedResources };
  };

  const { loading } = useQuery(GET_SONGBOOK, {
    variables: { id },
    onCompleted: (res) => {
      dismissLoadingMessage();
      if (res?.esongbook) {
        const modifiedSongbook = appendTokenToSongbookAssets(res?.esongbook);
        setProcessedData({ esongbook: modifiedSongbook });
      } else {
        setProcessedData(res);
      }
    },
    onError: () => {
      dismissLoadingMessage();
      displayErrorMessage();
    },
  });

  loading && displayLoadingMessage('Loading songbook...');

  return { data: processedData };
};

export default useGetSongbook;
